import { API_AUTH_RESET } from "../../constants/API";
import {
  CAMERAS_CLEAR_PANE,
  CAMERAS_SET_CURRENT_CAMERA
}                         from '../../constants/cameras';
import { initialState }   from "./initialState";
import {
  LayoutAction,
  LayoutState
}                         from "./types";

const reducer = (state: LayoutState = initialState, action: LayoutAction) => {
  switch (action.type) {
    case 'triggerLayoutList' :
      return {
        ...state,
        openedLayoutList: action.openedLayoutList,
        speedPickerIsOpened: false
      };

    case 'expandLayoutList' :
      return {
        ...state,
        expandedLayoutList: action.expandedLayoutList,
      };

    case 'expandVideoLayout' :
      return {
        ...state,
        expandedVideoLayout: action.expandedVideoLayout
      };

    case 'shrankVideoLayout' :
      return {
        ...state,
        expandedVideoLayout: null
      };

    case('setCurrentLayout'):
      return {
        ...state,
        openedLayoutList: false,
        currentLayoutChanged: !state.currentLayoutChanged,
        currentLayout: action.currentLayout,
        currentLayoutType: action.currentLayoutType,
        speedPickerIsOpened: false,
        expandedVideoLayout: null,
        checkedPane: null,
        activeViewPosition: action.activeViewPosition ? action.activeViewPosition : state.activeViewPosition
      };

    case('setCurrentLayoutChanged'):
      return {
        ...state,
        currentLayoutChanged: !state.currentLayoutChanged
      }

    case('setCheckedPane'):
      return {
        ...state,
        checkedPane: action.pane,
        openedLayoutList: false,
        speedPickerIsOpened: false
      };

    case('shutAlllists'):
      return {
        ...state,
        openedLayoutList: false,
        speedPickerIsOpened: false
      };

    case('setInitialCameras'): {
      delete state.initialCameras;

      return {
        ...state,
        initialCameras: action.cameras
      }
    }

    case('setExportWindowSize'):
      return {
        ...state,
        exportWindowSize: {
          width: action.size.width,
          height: action.size.height
        }
      }

    //*****************

    case('setOpenedCameraList'):
      return {
        ...state,
        openedLayoutList: false,
      };

    case CAMERAS_SET_CURRENT_CAMERA:
      return {
        ...state,
        currentLayout: {
          ...state.currentLayout,
          camerasIds: {
            ...state.currentLayout.camerasIds,
            [action.pane]: action.camera.id
          }
        }
      };

    case('triggerDatepicker') :
      return {
        ...state,
        datePickerIsOpened: action.datePickerIsOpened,
        speedPickerIsOpened: false
      };

    case('triggerSpeedPicker') :
      return {
        ...state,
        speedPickerIsOpened: action.speedPickerIsOpened,
        datePickerIsOpened: false
      };

    case('triggerExportAviList') :
      return {
        ...state,
        exportAVIListOpened: !state.exportAVIListOpened
      };

    case('triggerExportStatusList') :
      return {
        ...state,
        exportStatusListOpened: !state.exportStatusListOpened,
        exportAVIListOpened: false
      };

    case('setAVIId'):
      return {
        ...state,
        exportShareStatusIsOpened: true
      };

    case('closeShareStatus'):
      return {
        ...state,
        exportShareStatusIsOpened: false
      };

    case('closeWarningException'):
      return {
        ...state,
        warningExceptionIsOpened: false,
        warningMessage: ''
      };

    case('openWarningException'):
      return {
        ...state,
        warningExceptionIsOpened: true,
        exportAVIListOpened: false,
        warningMessage: action.message
      };

    case API_AUTH_RESET :
      return {
        ...initialState
      };

    case('triggerAcknowledgeTable'):
      return {
        ...state,
        acknowledgeFormIsOpened: action.opened
      };

    case('triggerHelpTable'):
      return {
        ...state,
        helpTableOpened: action.opened
      };

    case('triggerAboutTable'):
      return {
        ...state,
        aboutTableOpened: action.opened
      };

    case('setIsLoaded'):
      return {
        ...state,
        isLoaded: action.isLoaded
      };

    case('setBookmarkCheckedPane'):
      return {
        ...state,
        checkedPane: action.pane
      }

    case CAMERAS_CLEAR_PANE:
      return {
        ...state,
        currentLayout: {
          ...state.currentLayout,
          camerasIds: {
            ...state.currentLayout.camerasIds,
            [action.pane]: null
          }
        }
      }

    default:
      return {...state}
  }
};

export default reducer